import { gql } from '@apollo/client';
import { ErrorMessageInfo } from '@retainerclub/shared-api';

export default gql`
  mutation createSubscriptionAcknowledgment(
    $input: SubscriptionAcknowledgmentCreateInput!
  ) {
    createSubscriptionAcknowledgment(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      accountEvent {
        id
        eventType
        area
        typedName
        disclosureVersion
        occurredAt
      }
    }
  }
  ${ErrorMessageInfo}
`;
